export enum LandingPageStyle {
  BLUE,
  ORANGE
}